module.exports = __webpack_public_path__ + "img/paypal.849b2ca6.png";